export default {
    url: '/calendar',
    template: '<planning-calendar classifiers="vm.classifiers" />',
    resolve: {
        classifiers (ClassifierResource) {
            return ClassifierResource.query({ pageSize: 0 }).$promise;
        }
    },
    controller (classifiers) {
        this.classifiers = classifiers;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/planning/calendar/index.js